import { Directive, ElementRef, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Validator, NG_VALIDATORS, FormControl, NgControl } from '@angular/forms';

import { CnpjCpfService } from '../../../core';

@Directive({
    selector: '[sgtCnpjRaiz]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CnpjRaizDirective), multi: true }
    ]
})
export class CnpjRaizDirective implements OnChanges, Validator {
    element: any;

    @Output() ngModelChange = new EventEmitter<string>();
    @Input() ngControl: NgControl;
    @Input() isValidate = true; // Se deve validar o CNPJ Raiz
    @Input() isApplyMask = true; // Se deve aplicar a máscara do CNPJ Raiz

    constructor(private el: ElementRef, private cnpjCpfService: CnpjCpfService) {
        this.element = jQuery(this.el.nativeElement) as any;

        if (this.isApplyMask) {
            this.applyMask();
        }

        /** Ao colar algum valor no input, formatamos ele */
        this.element.on('paste', (e) => {
            if (this.isApplyMask) {
                let value = (e.originalEvent || e).clipboardData.getData('text/plain') as string;
                value = this.element.masked(value) as string;
                this.ngModelChange.emit(value);
            }
        });
    }

    /** Aplica a máscara no elemento */
    private applyMask() {
        this.element.mask('00.000.000', { placeholder: '__.___.___' });
    }

    /** Remove a máscara aplicada no elemento */
    private removeMask() {
        this.element.unmask();
        this.element.removeAttr('placeholder');
    }

    /** Realiza a validação do FormControl de CNPJ Raiz */
    validate(c: FormControl) {
        if (!this.isValidate) {
            return null;
        }

        // Validando apenas a parte do CNPJ Raiz
        const isValid = this.cnpjCpfService.validarCnpjRaiz(c.value);
        if (!isValid) {
            return {
                cnpjRaizInvalido: {
                    valid: false
                }
            };
        }
        return null;
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isValidate') {
                if (!changes[propName].isFirstChange()) {
                    this.ngControl.control.updateValueAndValidity();
                }
            } else if (propName === 'isApplyMask') {
                if (this.isApplyMask) {
                    this.applyMask();
                } else {
                    this.removeMask();
                }
            }
        }
    }
}
